import React, { useEffect, useState } from 'react';
import { deleteReqCategories, getRequesCategories } from '../services/requestService';
import { EditIcon } from '../assets/icons';
import CreateUserModal from '../components/UserModals/CreateRequestModal';
import EditUserModal from '../components/UserModals/EditRequestModal';
import ActionButton from '../components/common/ActionButton';
import HazirCevaplarModal from '../components/UserModals/HazirCevaplarModal';

const TalepKategorileri = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [hazirCevapCategory, setHazirCevapCategory] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);


  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getRequesCategories();

      setUsers(data.data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      setError('Kullanıcı listesi yüklenirken bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  const handleDelete = async (user) => {
      setIsLoading(true);
      setError(null);
  
      try {
       var dd= await deleteReqCategories(user.id);
        // Update the user's status in the local state
        if(dd==1){
          setUsers(prevUsers => 
            prevUsers.map(u => 
              u.id === user.id 
                ? { ...u, aktifmi: !u.aktifmi }
                : u
            )
          );
          window.location.reload()
        }else{
 
        }
       
      } catch (error) {
        setError('Kullanıcı durumu güncellenirken bir hata oluştu.');
        console.error('User status update error:', error);
      } finally {
        setIsLoading(false);
      }
  };

  const handleCreateSuccess = (newUser) => {
    setUsers(prevUsers => [...prevUsers, newUser]);
  };

  const handleEditSuccess = (updatedUser) => {
    setUsers(prevUsers => 
      prevUsers.map(user => 
        user.id === updatedUser.id ? updatedUser : user
      )
    );
  };

  if (isLoading) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Kategoriler</h1>
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Kategoriler</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="people-container">
      <h1 className="page-title">Kayıtlı Kategoriler</h1>
      <div className='add-and-search-container'>
        <ActionButton 
          title="Yeni Kategori Ekle"
          onClick={() => setCreateModalOpen(true)}
        />
        {/* <div className='search-container'>
          <input type='text' placeholder='Kişi ismini yazınız.' />
          <select name='order' id='order'>
                <option value='asc'>Artan</option>
                <option value='desc'>Azalan</option>
            </select>
        </div> */}
      </div>
      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Kategori Adı</th>
              <th>Tür</th>
              <th>Açıklama</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.adi}</td>
                <td>{user.tur || '-'}</td>
                <td>{user.aciklama || '-'}</td>
                <td className="actions">
                  <button 
                    className="icon-button edit"
                    onClick={() => handleEdit(user)}
                    title="Düzenle"
                  >
                    Düzenle
                    <EditIcon color='black' />
                  </button>
                  <button
                    className="icon-button edit"
                    onClick={() => setHazirCevapCategory(user)}
                    title="Hazır Cevaplar"
                  >
                    Hazır Cevaplar
                  </button>
                  <button 
                    className={`icon-button status ${user.aktifmi ? 'active' : 'passive'}`}
                    onClick={() => handleDelete(user)}
                    title={user.aktifmi ? 'Sil' : 'Sil'}
                  >
                    <div className="status-indicator">
                      {user.aktifmi ? 'Sil' : 'Sil'}
                      <input 
                        type="radio" 
                        checked={user.aktifmi} 
                        readOnly 
                      />
                    </div>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <CreateUserModal 
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      <HazirCevaplarModal
        isOpen={!!hazirCevapCategory}
        onClose={() => setHazirCevapCategory(null)}
        category={hazirCevapCategory}
      />

      {selectedUser && (
        <>
          <EditUserModal
            isOpen={editModalOpen}
            onClose={() => {
              setEditModalOpen(false);
              setSelectedUser(null);
            }}
            user={selectedUser}
            onSuccess={handleEditSuccess}
          />
        </>
      )}
    </div>
  );
};

export default TalepKategorileri;
